import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { api } from '@/lib/api'
import { t } from '@/lib/i18n'

// OAuthLoginPage completes Ory Hydra's login challenge. Hydra redirects the
// browser here; this page is protected, so by the time it renders the user has
// a valid session (in-memory JWT). It posts the challenge to the authenticated
// accept-login endpoint and forwards the browser to Hydra's redirect_to.
export function OAuthLoginPage() {
  const [params] = useSearchParams()
  const [error, setError] = useState('')

  useEffect(() => {
    const challenge = params.get('login_challenge')
    if (!challenge) { setError(t('oauthMissingChallenge')); return }
    let cancelled = false
    api.post<{ redirect_to: string }>('/api/oauth/accept-login', { login_challenge: challenge })
      .then(res => { if (!cancelled && res.redirect_to) window.location.href = res.redirect_to })
      .catch(() => { if (!cancelled) setError(t('oauthFailed')) })
    return () => { cancelled = true }
  }, [params])

  return (
    <div style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: 12, color: 'var(--muted)' }}>
      {error
        ? <div style={{ color: 'var(--red)', fontSize: 14 }}>{error}</div>
        : <div style={{ fontSize: 14 }}>{t('oauthConnecting')}</div>}
    </div>
  )
}
